import { useEffect, useState } from 'react'
import { useSnackbar } from "notistack"
import { FormControl, InputLabel, Select, MenuItem, Grid, TextField, Button } from '@material-ui/core'
import TipoOficio from '../../../enums/tipoOficio'
import PesquisaProcessual from '../../data_display/Oficios/CriarEditarOficio/_pesquisaProcessual'
import PesquisaInteressados from '../../data_display/Oficios/CriarEditarOficio/_pesquisaInteressado'
import OficioService from '../../../services/OficioService'
import InputAdornment from "@material-ui/core/InputAdornment"
import { semNumeroNegativoInput } from '../../../utils/semNumeroNegativoInput'
import { capitalize } from '../../../functions'
import { v4 as uuid } from 'uuid'
import "date-fns"
import DateFnsUtils from "@date-io/date-fns"
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers"
import ptBRLocale from "date-fns/locale/pt-BR"
import SimNao from '../../../enums/simNao'
import { getChaveMenu } from '../../../utils/getChaveMenu'
import webconfig from '../../../webconfig.json'

const localeMap = {
    ptBR: ptBRLocale
}

export default function Filters({
    match,
    pagina,
    qtdePagina,
    getSubMenu,
    setOficios,
    setOficiosFixados,
    setTotalPaginas,
    setPaginaAtual,
    setItensPorPagina,
    loading,
    setLoading,
    setError,
    setErrorMensagem,
    handleLimparPesquisa
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [tipoOficio, setTipoOficio] = useState('');
    const [dadosTela, setDadosTela] = useState({
        analistasDoSetor: [],
        descritores: []
    });

    const idsAutuacao = [];
    const idsInteressados = [];
    const idsAnalistaDoSetor = [];

    const [oficioRecebido, setOficioRecebido] = useState(false);
    const [numeroOficio, setNumeroOficio] = useState("");
    const [anoOficio, setAnoOficio] = useState("");

    const [pesquisaProcessual, setPesquisaProcessual] = useState([]);
    const [pesquisaInteressados, setPesquisaInteressados] = useState([]);

    const [analistaDoSetor, setAnalistaDoSetor] = useState('');
    const [situacaoOficio, setSituacaoOficio] = useState('');

    const [oficioResposta, setOficioResposta] = useState(false);
    const [oficioProrrogacao, setOficioProrrogacao] = useState(false);
    const [oficioRecurso, setOficioRecurso] = useState(false);

    const [dataInicio, setDataInicio] = useState(
        new Date()
    );

    const handleClosePopover = () => {
        document.getElementById("btn-popover-filter-search-bar-close").click();
    }

    const handleDataInicioChange = (date) => {
        setDataInicio(date)
    };

    const [dataFinal, setDataFinal] = useState(
        new Date()
    );

    const handleDataFinalChange = (date) => {
        setDataFinal(date)
    };

    const handleOficioRecebidoChange = () => {
        setOficioRecebido(!oficioRecebido);
    };

    const handleOficioRespostaChange = () => {
        setOficioResposta(!oficioResposta);
    };

    const handleOficioProrrogacaoChange = () => {
        setOficioProrrogacao(!oficioProrrogacao);
    };

    const handleOficioRecursoChange = () => {
        setOficioRecurso(!oficioRecurso);
    };

    useEffect(() => {
        let estaMontado = false;

        (async function () {
            OficioService.ConsultaDadosPesquisaAvancada()
                .then(response => {
                    if (!estaMontado) {
                        setDadosTela(response.data);
                    }
                })
                .catch(error => {
                    if (!estaMontado) {
                        enqueueSnackbar(error.toString(), { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration });
                    }
                })
        })();

        return () => {
            estaMontado = true;
        };
    }, [enqueueSnackbar]);

    const realizePesquisaAvancada = (e) => {
        e.preventDefault();

        if (analistaDoSetor !== null
            && analistaDoSetor !== undefined
            && analistaDoSetor !== "") {
            idsAnalistaDoSetor.push(analistaDoSetor);
        }

        pesquisaProcessual.forEach(processo => {
            idsAutuacao.push(processo.autuacaoId)
        });

        pesquisaInteressados.forEach(interessado => {
            idsInteressados.push(interessado.pessoaId)
        });

        handleClosePopover();
        setLoading(true);

        let parametrosConsultaAvancada = {
            tipoOficio: tipoOficio,
            situacaoOficio: (situacaoOficio !== "") ? situacaoOficio : null,
            numeroOficio: (numeroOficio !== "") ? numeroOficio : null,
            anoOficio: (anoOficio !== "") ? anoOficio : null,
            listaNumerosProcessos: (idsAutuacao.length > 0) ? idsAutuacao : null,
            listaIdsInteressados: (idsInteressados.length > 0) ? idsInteressados : null,
            listaIdsAnalistasResponsaveis: (idsAnalistaDoSetor.length > 0) ? idsAnalistaDoSetor : null,
            oficioRecebido: (oficioRecebido === true) ? SimNao.SIM : null,
            inicioPeriodoRecebimentoOficio: (oficioRecebido === true && dataInicio !== null) ? dataInicio.toJSON() : null,
            finalPeriodoRecebimentoOficio: (oficioRecebido === true && dataFinal !== null) ? dataFinal.toJSON() : null,
            oficioComResposta: (oficioResposta === true) ? SimNao.SIM : null,
            oficioComSolicitacaoProrrogacaoPrazo: (oficioProrrogacao === true) ? SimNao.SIM : null,
            oficioComRecurso: (oficioRecurso === true) ? SimNao.SIM : null,
        };

        let parametroConsultaRapida = '';

        OficioService.SubMenuComFiltroAvancado(1, 999, getChaveMenu(match.params.tipo), parametroConsultaRapida, parametrosConsultaAvancada)
            .then(response => {
                setOficios(response.data.itensNaoFixados);
                setOficiosFixados(response.data.itensFixados);
                setTotalPaginas(response.data.paginacao.totalPaginas);
                setPaginaAtual(response.data.paginacao.paginaAtual);
                setItensPorPagina(response.data.paginacao.itensPorPagina);
                setLoading(false);
                setError(false);
            })
            .catch(error => {
                setLoading(false);
                setOficios([]);
                setError(true);
                setErrorMensagem(error.response);
            })
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <FormControl variant="outlined">
                    <InputLabel id="select-outlined-label-prioridade">Tipo</InputLabel>
                    <Select
                        labelId="select-outlined-label-prioridade"
                        id="select-outlined-prioridade"
                        value={tipoOficio}
                        onChange={e => setTipoOficio(e.target.value)}
                        label="Prioridade"
                        disabled={loading}
                        placeholder=" ">
                        <MenuItem value={''}>
                            <em>Selecione uma opção</em>
                        </MenuItem>
                        <MenuItem value={TipoOficio.NORMAL}>Normal</MenuItem>
                        <MenuItem value={TipoOficio.PRAZO}>Prazo</MenuItem>
                        <MenuItem value={TipoOficio.DEBITO_MULTA}>Débito / Multa</MenuItem>
                        <MenuItem value={TipoOficio.MEDIDA_CAUTELAR}>Medida Cautelar</MenuItem>
                        <MenuItem value={TipoOficio.CIRCULAR}>Circular</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <FormControl variant="outlined">
                    <TextField
                        id="outlined-basic-ticket"
                        variant="outlined"
                        type="tel"
                        label="Número"
                        value={numeroOficio}
                        onChange={event => semNumeroNegativoInput(event, setNumeroOficio)}
                        disabled={loading}
                        placeholder=" "
                        inputProps={{
                            maxLength: 18
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                <FormControl variant="outlined">
                    <TextField
                        id="outlined-basic-ticket"
                        variant="outlined"
                        type="tel"
                        label="Ano"
                        value={anoOficio}
                        onChange={event => semNumeroNegativoInput(event, setAnoOficio)}
                        disabled={loading}
                        placeholder=" "
                        inputProps={{
                            maxLength: 4
                        }}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <PesquisaProcessual
                    value={pesquisaProcessual}
                    setValue={setPesquisaProcessual}
                    error={null}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <PesquisaInteressados
                    value={pesquisaInteressados}
                    setValue={setPesquisaInteressados}
                    error={null}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormControl variant="outlined">
                    <InputLabel id="select-outlined-label-prioridade">Analista Responsável</InputLabel>
                    <Select
                        labelId="select-outlined-label-prioridade"
                        id="select-outlined-prioridade"
                        value={analistaDoSetor}
                        onChange={e => setAnalistaDoSetor(e.target.value)}
                        label="Prioridade"
                        disabled={loading}
                        placeholder=" ">
                        <MenuItem value={''}>
                            <em>Selecione uma opção</em>
                        </MenuItem>
                        {dadosTela.analistasDoSetor.map(analista => (
                            <MenuItem key={uuid()} value={analista.id}>{capitalize(analista.nome)}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormControl variant="outlined">
                    <InputLabel id="select-outlined-label-prioridade">Situação</InputLabel>
                    <Select
                        labelId="select-outlined-label-prioridade"
                        id="select-outlined-prioridade"
                        value={situacaoOficio}
                        onChange={e => setSituacaoOficio(e.target.value)}
                        label="Prioridade"
                        disabled={loading}
                        placeholder=" ">
                        <MenuItem value={''}>
                            <em>Selecione uma opção</em>
                        </MenuItem>
                        {dadosTela.descritores.map(descritor => (
                            <MenuItem key={uuid()} value={descritor.id}>{capitalize(descritor.descricao)}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
            {oficioRecebido && (<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <MuiPickersUtilsProvider locale={localeMap["ptBR"]} utils={DateFnsUtils}>
                    <KeyboardDatePicker
                        margin="normal"
                        id="date-picker-dialog"
                        inputVariant="outlined"
                        label="Início Período de Recebimento"
                        format="dd/MM/yyyy"
                        value={dataInicio}
                        onChange={handleDataInicioChange}
                        okLabel={'Selecionar'}
                        cancelLabel={'Fechar'}
                        KeyboardButtonProps={{
                            "aria-label": "change date"
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><span></span></InputAdornment>
                        }}
                    />
                </MuiPickersUtilsProvider>
            </Grid>)}
            {oficioRecebido && (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <MuiPickersUtilsProvider locale={localeMap["ptBR"]} utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-dialog"
                            inputVariant="outlined"
                            label="Final Período de Recebimento"
                            format="dd/MM/yyyy"
                            value={dataFinal}
                            onChange={handleDataFinalChange}
                            okLabel={'Selecionar'}
                            cancelLabel={'Fechar'}
                            KeyboardButtonProps={{
                                "aria-label": "change date"
                            }}
                            InputProps={{
                                startAdornment: <InputAdornment position="start"><span></span></InputAdornment>
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>)}
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="switch-label-filters">
                    <label className="form-switch">
                        <input
                            checked={oficioRecebido}
                            type="checkbox"
                            onChange={handleOficioRecebidoChange}
                        />
                        <i></i>
                    </label>
                    <span className="description-switch-label-filter">Ofícios recebidos</span>
                </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="switch-label-filters">
                    <label className="form-switch">
                        <input
                            checked={oficioResposta}
                            type="checkbox"
                            onChange={handleOficioRespostaChange}
                        />
                        <i></i>
                    </label>
                    <span className="description-switch-label-filter">Ofícios com resposta</span>
                </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="switch-label-filters">
                    <label className="form-switch">
                        <input
                            checked={oficioProrrogacao}
                            type="checkbox"
                            onChange={handleOficioProrrogacaoChange}
                        />
                        <i></i>
                    </label>
                    <span className="description-switch-label-filter">Ofícios com solicitação de prorrogação de prazo</span>
                </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <div className="switch-label-filters">
                    <label className="form-switch">
                        <input
                            checked={oficioRecurso}
                            type="checkbox"
                            onChange={handleOficioRecursoChange}
                        />
                        <i></i>
                    </label>
                    <span className="description-switch-label-filter">Ofícios com recurso</span>
                </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="action-search-filters-poopover">
                    <Button className='btn-clear-search-filters' onClick={handleLimparPesquisa}>Limpar</Button>
                    <Button className='btn-send-search-filters' onClick={e => realizePesquisaAvancada(e)}>Pesquisar</Button>
                </div>
            </Grid>
        </Grid>
    )
}